/* eslint-disable import/first */
import React, { useState, useRef } from 'react';

/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector, useDispatch } = Redux;
import { GoogleMap, useJsApiLoader, Marker } from '@react-google-maps/api';
import { useNavigate } from '@reach/router';
import { useIntl } from 'react-intl';
const { selectStoreEntities } = Slices.storeSlice;
const { selectCountryValidations } = Slices.configSlice;
import { generateStoreRoute } from 'spwa-ui-library/esm/utils/path';
import phlogo from './kfcpin.svg';
function StoreMap({ refineStoreList, zoom = 8.5, defaultLoc }) {
  const navigate = useNavigate();
  const profile = useSelector((state) => state.profile);
  const countryValidations = useSelector((state) =>
    selectCountryValidations(state, profile.country)
  );
  const [zoomIndex] = useState(zoom);
  const mapRef = useRef();
  const intl = useIntl();
  const [storeList, setStoreList] = useState(refineStoreList);
  const store = useSelector(selectStoreEntities);
  const containerStyle = {
    height: '100%',
    borderRadius: '1rem',
  };
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: process?.env?.REACT_APP_MAPS_API_KEY || '',
  });
  const [center, setCenter] = useState({
    lat: defaultLoc?.lat || countryValidations?.defaultLat,
    lng: defaultLoc?.lng || countryValidations?.defaultLng,
  });
  React.useEffect(() => {
    if (Object.keys(store).length) {
      setStoreList(refineStoreList);

      const storeDetail = store[refineStoreList[0]];
      setCenter({
        lat: storeDetail?.location?.latitude || countryValidations?.defaultLat || 0,
        lng: storeDetail?.location?.longitude || countryValidations?.defaultLng || 0,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refineStoreList, store]);
  const [map, setMap] = React.useState(null);
  const onLoad = React.useCallback(function callback(map) {
    setMap(map);
  }, []);
  const storeName = 'name_' + intl.locale.toLowerCase();
  const handleStoreNavigation = (e, storeDetail) => {
    const path = generateStoreRoute(storeDetail[storeName]);
    navigate(`/${intl.locale}${path}/${storeDetail.storeId}`);
  };

  return (
    <>
      {isLoaded && (
        <GoogleMap
          ref={mapRef}
          mapContainerStyle={containerStyle}
          center={center || {}}
          draggable={true}
          zoom={zoomIndex}
          options={{
            gestureHandling: 'greedy',
            clickableIcons: false,
            panControl: true,
            zoomControl: true,
            mapTypeControl: false,
            scaleControl: true,
            streetViewControl: false,
            overviewMapControl: false,
            rotateControl: !defaultLoc ? true : false,
            disableDefaultUI: !defaultLoc ? true : false,
            scrollwheel: true,
            disableDoubleClickZoom: true,
            maxZoom: 16,
            minZoom: 8,
          }}
        >
          {!defaultLoc ? (
            storeList.map((el) => {
              const storeDetail = store[el];
              const locPos = {
                lat: storeDetail.location.latitude,
                lng: storeDetail.location.longitude,
              };
              return (
                <Marker
                  icon={phlogo}
                  onLoad={onLoad}
                  key={storeDetail.name_en + storeDetail.id}
                  position={locPos}
                  onClick={(e) => handleStoreNavigation(e, storeDetail)}
                />
              );
            })
          ) : (
            <Marker icon={phlogo} onLoad={onLoad} position={defaultLoc} />
          )}
        </GoogleMap>
      )}
    </>
  );
}

export default StoreMap;
